<template>
  <div class="feedback-form-wrap">
    <div class="form-body">
      <slot/>
      <div class="feedback-steps-wrap">
        <div class="feedback-steps-wrap__line"></div>
        <div class="feedback-steps-wrap__numbers">
          <div class="feedback-steps-wrap__item-wrap">
            <div :class="{'feedback-steps-wrap__item_active': number === 1, 'feedback-steps-wrap__item': true }">1</div>
          </div>
          <div class="feedback-steps-wrap__item-wrap">
            <div :class="{'feedback-steps-wrap__item_active': number === 2, 'feedback-steps-wrap__item': true }">2</div>
          </div>
          <div class="feedback-steps-wrap__item-wrap">
            <div :class="{'feedback-steps-wrap__item_active': number === 3, 'feedback-steps-wrap__item': true }">3</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  anotherNameLife: "FormBody",
  props: {
    number: {
      type: Number,
      required: true,
    }
  }
}
</script>

<style scoped>
.feedback-form-wrap{
  margin: 0 auto;
  max-width: 890px;
  background-color: #e60028;
  border-radius: 5px;
  box-shadow: 2px 2px 9px rgba(0,0,0,.34902);
}

.form-body{
  margin-left: 16.666667%;
  margin-right: 2%;
  padding: 0.75rem;
  background-color: #fff;
}



@media (max-width: 768px) {
  .form-body{
    margin-left: 2%;
  }

  
}

.feedback-steps-wrap__line{
  width: 100%;
  height: 2px;
  background: #000;
  top: 0;
  bottom: 0;
  position: absolute;
  margin: auto;
}

.feedback-steps-wrap{
  position: relative;
  width: 100%;
  max-width: 450px;
  margin: auto;

}

.feedback-steps-wrap__numbers{
  display: -webkit-box;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin-top: 20px;
}

.feedback-steps-wrap__item-wrap{
  height: 65px;
  width: 65px;
  background: #fff;
  position: relative;
}

.feedback-steps-wrap__item, .feedback-steps-wrap__item-wrap {
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}

.feedback-steps-wrap__item{
  border: 2px solid #000;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-weight: 700;
  color: #e60028;
  align-content: center;
}

.feedback-steps-wrap__item_active{
  border: 2px solid #e60028;
}
</style>